<div class="card invoicing-list__card">
    <ul class="nav nav-tabs invoicing-list__tabs" role="tablist">
        <li class="nav-item" role="presentation">
            <button class="nav-link"
                    [class.active]="activeTab === 'invoices'"
                    type="button"
                    role="tab"
                    (click)="setTab('invoices')">
                <i class="ti ti-file-invoice"></i>
                Listado de facturas
            </button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link"
                    [class.active]="activeTab === 'receivable'"
                    type="button"
                    role="tab"
                    (click)="setTab('receivable')">
                <i class="ti ti-currency-dollar"></i>
                Cuentas por cobrar
            </button>
        </li>
    </ul>

    <div class="card-body invoicing-list__body" *ngIf="activeTab === 'invoices'">
        <app-invoices-panel></app-invoices-panel>
    </div>

    <div class="card-body invoicing-list__body" *ngIf="activeTab === 'receivable'">
        <app-receivable-panel></app-receivable-panel>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
